import { ThemeEnum } from '../../handlers/ThemeHandler';
import { translations } from './interfaces';
import LightTiles from './images/lightTiles.png';
import DarkTiles from './images/darkTiles.png';
import EnLogo from './images/en-logo.png';
import DeLogo from './images/de-logo.png';
import { Text, View } from '@react-pdf/renderer';
import { styles } from './styles';
import { LanguagesEnum } from '../../handlers/TranslationsHandler';

export const coverImage = (translations: translations) =>
  translations.theme === ThemeEnum[ThemeEnum.light] ? LightTiles : DarkTiles;

export const sideLogo = (language: string) =>
  language === LanguagesEnum.EN ? EnLogo : DeLogo;

export const PageNumberFooter = () => (
  <View style={styles.lineContainer}>
    <Text style={styles.footer} render={({ pageNumber }) => pageNumber} />
  </View>
);
